import PropTypes from 'prop-types';
import React from 'react';

function InfoCard({
  title, blueColor = false, children, subtitle, extra, className,
}) {
  return (
    <div className={className}>
      <div className="flex items-start justify-between">
        <h2 className="text-[22px] font-semibold mb-1">{title}</h2>
        {extra}
      </div>
      <p className="text-sm text-gray-600 mb-2">{subtitle}</p>
      {children && (
        <div
          className={`border border-[1px] border-[#B8E5FF] rounded-[6px] px-[9px] py-5 ${blueColor ? 'bg-[#DBF2FF70]' : 'bg-white'}`}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default InfoCard;

InfoCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  extra: PropTypes.node,
  className: PropTypes.string,
  blueColor: PropTypes.bool,
};
